/**
 * WordPress dependencies
 */
const { Component, render } = wp.element;

/**
 * Internal dependencies
 */
import Mapping from './mapping';

class FieldMap extends Component {

	constructor() {

		super( ...arguments );

		/**
		 * State is managed via the value attribute on a hidden input that
		 * is output via the markup() method in class-generic-map.php. This value
		 * is set on initial load via that method in the php.
		 */
		this.state = {
			mapping: JSON.parse( document.querySelector( `[name="${ this.props.input }"]` ).value )
		};
		this.addMapping = this.addMapping.bind( this );
		this.deleteMapping = this.deleteMapping.bind( this );
		this.getMapping = this.getMapping.bind( this );
		this.updateMapping = this.updateMapping.bind( this );
	}

	componentDidMount() {

		this.populateRequiredMappings();

		// Ensure there is at least one item.
		if ( this.getRequiredChoices().length === 0 && this.getMapping().length < 1 ) {
			this.addMapping( 0 );
		}

	}





	// # MAPPING DATA METHODS ------------------------------------------------------------------------------------------

	/**
	 * Add a new mapping item.
	 *
	 * @param {integer} index Index to add item at.
	 */
	addMapping( index ) {

		const { allow_custom, choices } = this.props.keyField;

		let mapping = this.getMapping(),
			key = choices.length === 0 && allow_custom ? 'gf_custom' : '';

		mapping.splice( index + 1, 0, {
			key:          key,
			custom_key:   '',
			value:        '',
			custom_value: '',
		} );

		this.setMapping( mapping );

	}

	/**
	 * Remove a mapping item.
	 *
	 * @param {integer} index Index of item to remove.
	 */
	deleteMapping( index ) {

		let mapping = this.getMapping();

		mapping.splice( index, 1 );

		this.setMapping( mapping );

	}

	/**
	 * Get current mappings.
	 *
	 * @returns {array}
	 */
	getMapping() {

		return this.state.mapping;

	}

	/**
	 * Set current mappings.
	 *
	 * @param {object} mapping Collection of field mappings.
	 */
	setMapping( mapping ) {

		const { input } = this.props;

		this.setState( { mapping } );

		document.querySelector( `[name="${ input }"]` ).value = JSON.stringify( mapping );

	}

	/**
	 * Update a mapping item.
	 *
	 * @param {object} item Mapping item.
	 * @param {integer} index Index of item to update.
	 */
	updateMapping( item, index ) {

		let mapping = this.getMapping();

		if ( ! item.key ) {
			item.value = '';
		}

		mapping[ index ] = item;

		this.setMapping( mapping );

	}





	// # CHOICE METHODS ------------------------------------------------------------------------------------------------

	/**
	 * Get choice properties by name.
	 *
	 * @since 2.5
	 *
	 * @param {string} name Choice name.
	 * @param {array} choices Choices to search in.
	 *
	 * @returns {boolean|object}
	 */
	getChoice( name, choices = false ) {

		if ( ! choices ) {
			choices = this.props.keyField.choices;
		}

		for ( let i = 0; i < choices.length; i++ ) {

			let choice = choices[ i ],
			    choiceName = choice.name || choice.value;

			if ( choiceName === name ) {
				return choices[ i ];
			}

			if ( choice.choices ) {
				let foundChoice = this.getChoice( name, choice.choices );
				if ( foundChoice ) {
					return foundChoice;
				}
			}

		}

		return false;

	}

	/**
	 * Get names of mapped choices.
	 */
	getMappedChoices() {

		const mapping = this.getMapping();

		return mapping.filter( ( m ) => m.key && m.key !== 'gf_custom' ).map( ( m ) => m.key );

	}

	/**
	 * Get names of required choices.
	 *
	 * @returns {array}
	 */
	getRequiredChoices() {
		const { choices, display_all } = this.props.keyField;
		let requiredChoices = [];

		for ( let i = 0; i < choices.length; i++ ) {

			const choice = choices[ i ];

			if ( choice.required || display_all ) {
				requiredChoices.push( choice.name || choice.value );
			}

			if ( choice.choices ) {

				for ( let ii = 0; ii < choice.choices.length; ii++ ) {
					let subChoice = choice.choices[ ii ];

					if ( subChoice.required || display_all ) {
						requiredChoices.push( subChoice.name || subChoice.value );
					}
				}

			}

		}

		return requiredChoices;

	}

	/**
	 * Populate mapping with required choices.
	 */
	populateRequiredMappings() {

		const mapping = this.getMapping();
		const requiredChoices = this.getRequiredChoices();

		// Get mapped fields.
		const mappedFields = mapping.map( ( mapping ) => mapping.key );

		// Loop through required choices. If not mapped, add to mapping.
		for ( let i = 0; i < requiredChoices.length; i++ ) {

			// If field is mapped, skip.
			if ( mappedFields.includes( requiredChoices[ i ] ) ) {
				continue;
			}

			// Add to mapping.
			mapping.push( {
				key:          requiredChoices[ i ],
				custom_key:   '',
				value:        '',
				custom_value: '',
			} );

		}

		// Auto populate default values.
		for ( let i = 0; i < mapping.length; i ++ ) {
			// If field have a stored value already, skip.
			if ( mapping[ i ].value !== '' ) {
				continue;
			}

			let choice = this.getChoice( mapping[ i ].key );
			// If choice have a default value, get it and set it as value.
			if ( choice && 'default_value' in choice ) {
				mapping[ i ].value = choice.default_value;
			}
		}

		this.setMapping( mapping );

	}

	// Count how many possible choices there are.
	countKeyFieldChoices() {

		const { choices } = this.props.keyField;

		let count = 0;

		for ( let i = 0; i < choices.length; i ++ ) {
			if ( choices[ i ].choices ) {
				count += choices[ i ].choices.length;
			} else {
				count++;
			}
		}

		return count;

	}




	// # RENDER METHODS ------------------------------------------------------------------------------------------------

	render() {

		const { keyField, invalidChoices, limit, valueField, input, inputType, mergeTagSupport } = this.props;
		const mapping  = this.getMapping();
		const keyCount = this.countKeyFieldChoices();

		return (
			<table className="gform-settings-generic-map__table" cellSpacing="0" cellPadding="0">
				<tbody>
				<tr className="gform-settings-generic-map__row">
					<th className="gform-settings-generic-map__column gform-settings-generic-map__column--heading gform-settings-generic-map__column--key">{ keyField.title }</th>
					<th className="gform-settings-generic-map__column gform-settings-generic-map__column--heading gform-settings-generic-map__column--value">{ valueField.title }</th>
					<th className="gform-settings-generic-map__column gform-settings-generic-map__column--heading gform-settings-generic-map__column--error"></th>
					<th className="gform-settings-generic-map__column gform-settings-generic-map__column--heading gform-settings-generic-map__column--buttons"></th>
				</tr>
				{
					mapping.map(
						( m, index ) => {

							let selectedChoice = this.getChoice( m.key );

							return <Mapping
								key={ index }
								mapping={ m }
								choice={ selectedChoice }
								mappedChoices={ this.getMappedChoices() }
								isInvalid={ m.key && invalidChoices.includes( m.key ) }
								keyField={ keyField }
								valueField={ valueField }
								canAdd={ ( keyField.allow_custom && ( limit === 0 || mapping.length <= limit ) ) || ( ! keyField.allow_custom && mapping.length < keyCount ) }
								canDelete={ mapping.length > 1 && ! selectedChoice.required && ! keyField.display_all }
								addMapping={ this.addMapping }
								deleteMapping={ this.deleteMapping }
								updateMapping={ this.updateMapping }
								index={ index }
								inputId={ input }
								inputType={ inputType }
								mergeTagSupport={ mergeTagSupport }
							/>
						}
					)
				}
				</tbody>
			</table>
		)

	}

}

window.initializeFieldMap = ( container, props ) => {

	render(
		<FieldMap
			{...props}
		/>,
		document.getElementById( container )
	);

};
